import * as React from 'react'

import { GridBoxList } from '@factorialco/deprecated-design-system'
import { PolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Item from './Item'

interface TimeoffPoliciesProps {
  timeoffPolicies: PolicyFragment[]
  totalCount: number | null | undefined
}

const TimeoffPolicies: React.FC<TimeoffPoliciesProps> = ({ timeoffPolicies, totalCount }) => {
  const centered = totalCount ? totalCount < 2 : false

  return (
    <GridBoxList centered={centered}>
      {timeoffPolicies.map((policy: PolicyFragment) => (
        <Item key={policy.id} policy={policy} totalCount={totalCount} />
      ))}
    </GridBoxList>
  )
}

export default observer(TimeoffPolicies)
